import {Component, Input, OnInit} from '@angular/core';
import {DigitalInDescriptionDataservice} from "../digitalin-description-dataservice";
import {DigitalinlistComponent} from "../digitalinlist/digitalinlist.component";
import {DigitalInDescription, DInDescription} from "../digitalInDescription";
import {interval, Subscription} from "rxjs";
import {DIState} from "../digitalInStatus";


@Component({
  selector: 'app-digitalindetails',
  templateUrl: './digitalindetails.component.html',
  styleUrls: ['./digitalindetails.component.css']
})
export class DigitalindetailsComponent implements OnInit {
  @Input()
  refNumber: number = -1;
  checked: boolean = false;
  diDescription: DInDescription;
  diStatus: DIState;

  constructor(private digitalinlistComponent: DigitalinlistComponent) {
    this.diDescription = new DInDescription();
    this.diStatus = new DIState();
    this.checked = false;
    digitalinlistComponent.Add(this);
  }

  UpdateLayoutData(diDescription: DInDescription): void
  {
    this.diDescription = diDescription;
  }
  UpdateDiState(diState: DIState): void
  {
    this.diStatus = diState;
    this.checked = (this.diStatus.value) ? true :false;
  }

  ngOnInit(): void {
  }
}
